import * as React from "react";

import "./addressable-shipping-options.scss";

import {cs}   from "@Common/react/chain-services";
import {scnv} from "@Common/react/state-change-nested-value";

import {HeaderOptions} from "../header-options/header-options";

export const AddressableShippingOptions = (
    {
        state,
        subSections,
    }
) => cs(
    ({}) => (
        <div className="addressable-shipping-options-83u">

            {state && HeaderOptions({
                className: "section",
                list: narratives.map((c) => ({
                    key: c.value,
                    selected: c.value === !!state.value,
                    labels: c.labels,
                    description: c.description,
                    onSelect: () => scnv(state, [], () => c.value),
                })),
            })}

            {...subSections}

            {/*{renderAddressLists ? <>*/}
            {/*    {renderAddressLists()}*/}

            {/*    {ncoaFailedState && (*/}
            {/*        <div*/}
            {/*            className="section"*/}
            {/*        >*/}
            {/*            {NcoaFailed({*/}
            {/*                ...ncoaFailedState,*/}
            {/*            })}*/}
            {/*        </div>*/}
            {/*    )}*/}
            {/*</> : quantityUi && (*/}
            {/*    <div className="section">*/}
            {/*        {quantityUi({*/}
            {/*            showErrors,*/}
            {/*        })}*/}
            {/*    </div>*/}
            {/*)}*/}
        </div>
    ),
);

const narratives = [
    {
        value: false,
        labels: [
            {
                text: "Do NOT print addresses on my product",
            }
        ],
        description: "Select this option if you do not wish to add addresses to your cards.",
    },
    {
        value: true,
        labels: [
            {
                text: "Print addresses on my product",
            }
        ],
        description: "Select this option to have addresses printed on your cards. Select addressing options below.",
    },
];
